"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCluster = getCluster;
exports.getVideoType = getVideoType;
exports.toPascalCase = toPascalCase;
exports.toSumoFormat = toSumoFormat;
require("whatwg-fetch");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /**
 * Module that provides utility functions for logging.
 *
 * @module LoggerUtils
 */
var CLUSTER_HEADER = 'x-hudl-served-by';
var CLUSTER_UNKNOWN = 'Unknown';
function extractClusterHeader(response) {
  return response.headers.get(CLUSTER_HEADER) || CLUSTER_UNKNOWN;
}

/**
* Attempts to grab and parse the response header on the current request to return the cluster
*
* @return {string} The cluster name
*/
function getCluster() {
  return fetch(document.location, {
    credentials: 'include',
    method: 'HEAD'
  }).then(extractClusterHeader);
}

/**
 * Returns the video source type as a string. Possible values: `HLS`, `MP4`,
 * and `UNKNOWN`.
 * @param {string} src The video source path
 * @return {string} The video type (`HLS`, `MP4`, or `UNKNOWN`)
 */
function getVideoType(src) {
  if (/\.m3u8(\?v=.*)?/.test(src)) {
    return 'HLS';
  }
  if (/\.mp4(\?v=.*)?/.test(src)) {
    return 'MP4';
  }
  return 'UNKNOWN';
}

/**
 * Converts an object keys to Pascal Case, which is Camel Case with the first
 * character in upper case.
 * @param {object} obj The object who's keys will be changed
 * @return {object} A copy of the object parameter with its keys in Pascal Case
 */
function toPascalCase(obj) {
  var newObject = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var pascalKey = key[0].toUpperCase() + key.substring(1);
      newObject[pascalKey] = obj[key];
    }
  }
  return newObject;
}

/**
 * Converts an object to a string that follows the recommended logging format:
 * key-value pairs using '=', delimited by ',' and surrounded by '[]'.
 * @param {object} obj The object to be converted to the logging string
 * @return {string} The logging string
 */
function toSumoFormat(obj) {
  if (obj === null || typeof obj === 'undefined' || Object.keys(obj).length === 0) {
    return null;
  }
  if (typeof obj === 'string') {
    return obj;
  }
  var pascalObject = toPascalCase(obj);
  var sumoFormatArray = Object.keys(pascalObject).map(function (key) {
    var keyValue = _typeof(pascalObject[key]) === 'object' ? toSumoFormat(pascalObject[key]) : pascalObject[key];
    var sanitizedValue = keyValue === 0 ? 0 : keyValue || '(null)';
    return key + '=' + sanitizedValue;
  });
  return '[' + sumoFormatArray.join(',') + ']';
}